"use client";

import { AboutPageHero } from "@/components/about/AboutPageHero";
import { AboutIntroSection } from "@/components/about/AboutIntroSection";
import { AboutPurposeSection } from "@/components/about/AboutPurposeSection";
import { AboutStorySection } from "@/components/about/AboutStorySection";
import { AboutValuesSection } from "@/components/about/AboutValuesSection";
import { AboutFieldGallerySection } from "@/components/about/AboutFieldGallerySection";
import { AboutLeadershipSection } from "@/components/about/AboutLeadershipSection";
import { AboutClosingCTA } from "@/components/about/AboutClosingCTA";
import { WaveDivider } from "@/components/decorative/WaveDivider";
import { SitePageShell } from "@/components/layout/SitePageShell";
import type { AboutContent } from "@/lib/api-types";

interface AboutPageSectionsProps {
  content: AboutContent;
}

export function AboutPageSections({ content }: AboutPageSectionsProps) {
  return (
    <SitePageShell>
      <AboutPageHero hero={content.hero} />
      <WaveDivider palette="site" className="text-[var(--site-bg)]" />
      <AboutIntroSection intro={content.intro} />
      <WaveDivider palette="site" flip className="-mt-px text-[var(--site-surface)]" />
      <AboutPurposeSection purpose={content.purpose} />
      <AboutStorySection story={content.story} />
      <WaveDivider palette="site" flip className="-mt-px text-[var(--site-surface)]" />
      <AboutValuesSection values={content.values} />
      <AboutFieldGallerySection gallery={content.gallery} />
      <WaveDivider palette="site" flip className="-mt-px text-[var(--site-surface-alt)]" />
      <AboutLeadershipSection leadership={content.leadership} />
      <AboutClosingCTA closingCta={content.closingCta} />
    </SitePageShell>
  );
}
